import { HeadBannerType } from "../types"

export default function BaseHeadBanner(props: HeadBannerType) {
    return (
        <div className={`w-full bg-white shadow-lg px-8 sm:px-12 md:px-20 py-8 xl:p-8 rounded-default flex flex-row justify-between items-center relative h-16 md:h-24 ${props.classProps}`}>
            <h1 className="text-lg sm:text-xl md:text-2xl font-bold uppercase tracking-wider truncate text-black">{props.title}</h1>
            {props.button}
        </div>
    )
}
